import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { EventRow } from "web_myplann/Activities/Components/EventRow";
import { formatTaskDueDate } from "web_myplann/Activities/Helpers/formatTaskDueDate";
import { getTaskContact } from "web_myplann/Activities/Helpers/getTaskContact";
import {
	type TaskListItemResponseDTO,
	TimelineItemCategoryEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { AppRouting } from "web_myplann/Infrastructure/Utils/UrlUtils";
import { useFormatUserWithType } from "web_myplann/Shared/Hooks/useFormatUserWithType";
import type { EventRowVariant } from "web_myplann/Shared/Types/EventRowVariant";
import { mapTaskRowLines } from "web_myplann/Shared/Utils/mapTaskRowLines";

type Props = {
	data: TaskListItemResponseDTO;
	variant: EventRowVariant;
	showDivider: boolean;
	showPerson?: boolean;
};

export const TaskListRow: FC<Props> = ({
	data,
	variant,
	showDivider,
	showPerson = false,
}) => {
	const { t } = useResource();
	const navigate = useNavigate();
	const formatUserWithType = useFormatUserWithType();

	const lines = mapTaskRowLines({
		variant,
		taskLabel: t(Resources.Activity.List.Task),
		title: data.title,
		dueDate: formatTaskDueDate(data.date, data.time),
		person: showPerson ? formatUserWithType(getTaskContact(data)) : undefined,
	});

	return (
		<EventRow
			{...lines}
			category={TimelineItemCategoryEnum.Task}
			showDivider={showDivider}
			onClick={() =>
				navigate(AppRouting.MyPlann.TaskDetail.path(String(data.id)))
			}
		/>
	);
};
